export const STRING_LIST_DELIMITER = '|';
export const COMMA_LIST_DELIMITER = ',';
